import React, { useEffect } from 'react';

import { FullScreenLoader } from 'components/FullScreenLoader';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import { INSTAGRAM_AUTH_CODE_STORAGE_KEY } from 'shared/constants/auth-flows';

export function InstagramAuthPopupRedirect() {
  const location = useLocation();
  const { code } = queryString.parse(location.search);

  useEffect(() => {
    if (!code || typeof code !== 'string') return;

    localStorage.setItem(INSTAGRAM_AUTH_CODE_STORAGE_KEY, code);

    setTimeout(() => window.close(), 100);
  }, []);

  return <FullScreenLoader />;
}
